module.exports = {
  prefix: 'mobile-h5',
  fileService: 'file_web/file-service',
  routerPreFix: {
    commonCmsPage: 'common-cms-page',
    superAppUserV1: 'super/app/user/v1',
    userInfo: 'super/app/user-info',
    superMerchantV1: 'super/app/merchant/v1',
    superRiderV1: 'super/app/rider/v1',
    hybridJssdkTestPage: 'hybrid-jssdk-test-page',
    phoneRecharge: 'phone-recharge',
    checkoutCounter: "checkout-counter",
    downLoading: 'wownow/down-loading',
    guidePage: 'wownow/guide-page',
    invitationToRegister: 'marketing/invitation-to-register',
    luckyWinner: 'marketing/lucky-winner',
    luckyWinnerMacbook: 'marketing/lucky-winner-macbook',
    groupbuyShareStore: "marketing/groupbuy-share-store",
    groupbuyProductDetail: "marketing/groupbuy-product-detail",
    shareStore: 'marketing/share-store',
    freeBeer: 'marketing/free-beer',
    redPackage: 'marketing/red-package',
    foundPage: 'marketing/found-page',
    loginWelfare: 'marketing/login-welfare',
    shareBeer: 'marketing/share-beer',
    openIm: 'openIm',
    signIn: 'sign-in',
    integral: 'integral',
    questionnaire: 'questionnaire',
    versionUpdate: 'wownow/version-update',
    lottery: 'marketing/lottery',
    resetAccount: 'marketing/reset-account',
    longan: 'marketing/longan',
    annualDinner: 'marketing/annual-dinner',
    princeMall: 'marketing/prince-mall',
    merchantSettlement: 'marketing/merchant-settlement',
    merchantDownload: 'marketing/merchant-download',
    vip: 'vip',
    princehuanyuQuestionnaire: 'wownow-marketing/princehuanyu-questionnaire',
    starSelection: 'marketing/star-selection',
    scanCode: 'marketing/scan-code',
    luckyGoldenEgg: 'marketing/lucky-golden-egg',
    scanQRCodeOrderFood: 'marketing/scan-qrcode-order-food',
    freeCoupon: 'marketing/free-coupon',
    orderFood: 'marketing/order-food',
    redemptionCode: 'marketing/redemption-code',
    midautumnFestival: 'marketing/midautumn-festival',
    couponPackage: "marketing/coupon-package",
    christmasMysteryCoupon: "marketing/christmas-mystery-coupon",
    yearReport: 'marketing/year-report',
    superChatgpt: 'super/app/chatgpt',
    slowPay: "marketing/slow-pay",
    storePreview: "marketing/store-preview",
    merchantDownLoading: 'merchant/down-loading',
    shareCode: 'marketing/shareCode',
    missionShare: 'marketing/missionShare',
    taxiActivityCoupon: 'marketing/taxiActivityCoupon',
  }
}
